import type { SormDataAccess } from './sorm-data-access'

import { executeSormQuery } from '@moment/horizon-data-access'
import {
  getContexts,
  getEntity,
  listEntities,
  metricsQuery,
} from '@moment/horizon-data-access/platform'

/**
 * The platform SORM API (`/auth/v1/sorm/*`), which reads the organization
 * from the login session. Consumers fall back on it when nothing supplies a
 * data access.
 */
export const platformSormDataAccess: SormDataAccess = {
  scope: { api: 'platform' },
  async query(request, { queryName, signal }) {
    const response = await executeSormQuery(request, { queryName, signal })
    return response.data
  },
  async metrics(request, { queryName, signal }) {
    const response = await metricsQuery(request, { qn: queryName }, { signal })
    return response.data
  },
  async getEntity(entityName, { signal }) {
    const response = await getEntity({ entityName }, { signal })
    return response.data
  },
  async listEntities({ context, signal }) {
    const response = await listEntities(
      context === undefined ? undefined : { context },
      { signal },
    )
    return response.data
  },
  async getContexts({ signal }) {
    const response = await getContexts({ signal })
    return response.data
  },
}
